import { render, staticRenderFns } from "./list.vue?vue&type=template&id=38a79f7e"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38a79f7e')) {
      api.createRecord('38a79f7e', component.options)
    } else {
      api.reload('38a79f7e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=38a79f7e", function () {
      api.rerender('38a79f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/list.vue"
export default component.exports